var unitCurves = [
  "linear",
  "easeIn",
  "easeOut",
  "easeInOut",
  "circularEaseIn",
  "circularEaseOut",
  "circularEaseInOut"
];
var springPresets = [
  "smooth",
  "snappy",
  "bouncy"
];
export {
  springPresets,
  unitCurves
};
//# sourceMappingURL=animatorTypes.js.map
